module.exports = __webpack_public_path__ + "static/img/news23-2.1c0925d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news23-2.jpg
// module id = F8Wu
// module chunks = 0